import { useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import Home from "@/pages/Home";
import TermsOfService from "@/pages/TermsOfService";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Vault from "@/pages/Vault";

function WhopPageTracker() {
  const { pathname } = useLocation();
  const first = useRef(true);
  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    if (window.whop) window.whop.track("page");
  }, [pathname]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <WhopPageTracker />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/vault369" element={<Vault />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
